import API from "../configs/axiosInstance";

const getScannedPlatformsAndCounts = () => {
    return API({
        url: `/code-service/v1/repositories/count-by-platform`,
        method: 'GET',
    });
};

const getTotalBranchCount = () => {
    return API({
        url: `/code-service/v1/repositories/total-branch-count`,
        method: 'GET',
    });
};

const getTotalSeverityCount = () => {
    return API({
        url: `/code-service/v1/repository-scan-reports/count-all`,
        method: 'GET',
    });
};

const getSeverityTypesAndCounts = () => {
    return API({
        url: `/code-service/v1/repository-scan-reports/severity-summary`,
        method: 'GET',
    });
};

const getSeveritiesByScannedCode = () => {
    return API({
        url: `/code-service/v1/repository-scan-reports/vulnerability-count-by-repository`,
        method: 'GET',
    });
};

const getLatestCodeScans = () => {
    return API({
        url: `/code-service/v1/repository-scan-reports/latest-scan`,
        method: 'GET',
        params: {
            size: 10
        }
    });
};

const getSecretKeySeverityLevelsAndCounts = () => {
    return API({
        url: `/code-service/v1/repository-scan-reports/secret-severity-summary`,
        method: 'GET',
    });
};

const getTopCveTypesAndCounts = () => {
    return API({
        url: `/code-service/v1/repository-scan-reports/top-cwe-vulnerability`,
        method: 'GET',
        params: {
            size: 1000
        }
    });
};

const getTopVulnerabilitiesByPackages = () => {
    return API({
        url: `/code-service/v1/repository-scan-reports/top-vulnerable-package-by`,
        method: 'GET',
    });
};

const getAverageVulnerabilityByScans = () => {
    return API({
        url: `/code-service/v1/repository-scan-reports/average-vulnerability-per-scan`,
        method: 'GET',
    });
};

const getSecretKeyCategoriesAndCounts = () => {
    return API({
        url: `/code-service/v1/repository-scan-reports/secret-category-summary`,
        method: 'GET',
    });
};

const getScanStatusAndCounts = () => {
    return API({
        url: `/code-service/v1/repositories/count-by-scan-status`,
        method: 'GET',
    });
};

const codeService = {
    getScannedPlatformsAndCounts,
    getTotalBranchCount,
    getTotalSeverityCount,
    getSeverityTypesAndCounts,
    getSeveritiesByScannedCode,
    getLatestCodeScans,
    getSecretKeySeverityLevelsAndCounts,
    getTopCveTypesAndCounts,
    getTopVulnerabilitiesByPackages,
    getAverageVulnerabilityByScans,
    getSecretKeyCategoriesAndCounts,
    getScanStatusAndCounts
};

export default codeService;